import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';

import { loginGoogle } from '@/store/login/actions';

import { selectFiles } from '@/store/files/selectors';

import { Button, Form, message } from 'antd';
import LogoCompany from '@/components/LogoCompany';
import MarkdownViewer from '@/components/MarkdownViewer';

import { clearStorage } from '@/utils/clearStorage';
import { subscribeDevice } from '@/utils/pushManager';
// import { useLocalFileByUUID } from '@shared/hooks/localFiles';
import useIsMobile from '@shared/hooks/useIsMobile';
import { AUTH_TYPES } from '@shared/pages/Login/constants';
import { selectCompany } from '@shared/store/company/selectors';

import classNames from 'classnames';

import css from './Login.module.scss';

// import noIcon from '@/assets/icons/cannot-icon.svg';

const LoginOauth = () => {
  const { t } = useTranslation('registrationData');
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  const { setEntering, imageLogo } = useOutletContext();

  const { cacheFiles } = useSelector(selectFiles);
  const { company } = useSelector(selectCompany);

  const provider = company?.providers?.find(provider => provider.type === AUTH_TYPES.OAUTH);
  // const [currentProviderImg] = useLocalFileByUUID(provider?.icon, { defaultImg: noIcon, publish: true });

  const [isMobile] = useIsMobile(768);

  const handleLogin = () => {
    setEntering(true);
    dispatch(
      loginGoogle(
        provider?.name,
        (_response, headers) => {
          clearStorage();
          subscribeDevice();
          localStorage.setItem('externalLogin', 'true');
          window.location.replace(headers.get('Location'));
        },
        () => {
          messageApi.open({
            type: 'error',
            content: t('errorOauth'),
          });
          setEntering(false);
        }
      )
    );
  };

  return (
    <>
      {!isMobile && (
        <img alt='' src={cacheFiles[company?.background]} className={css['LoginPage-header__background']} />
      )}
      <div className={css['App-card-item']}>
        <div className={css['LoginPage-header__failure']}>
          <div className={css['LoginPage-header__logo']}>
            <LogoCompany imageLogo={cacheFiles[company?.logo] || imageLogo} />
          </div>
        </div>
        <Form className={classNames(css['LoginPage-form-google'], css.modif)}>
          <p className={css['LoginPage-header-oauth__subtitle']}>{t('welcome')}</p>
          <Button
            type={'primary'}
            className={css['LoginPage-form-google__googleBtn']}
            htmlType='submit'
            onClick={handleLogin}
            name={provider?.name}
            // icon={<img src={currentProviderImg} alt='' />} закомментировал по задаче https://kampus.atlassian.net/browse/KAM-6130
            size='large'
          >
            {provider?.label}
          </Button>
        </Form>
        <div className={css['LoginPage-label']}>
          <MarkdownViewer className={css['LoginPage-label-for4']} children={provider?.description} />
        </div>
      </div>
      {contextHolder}
    </>
  );
};

export default LoginOauth;
